import React, { useEffect, useState } from 'react';
import IssueApi from '@/fetch/bussiness/issue';
import { Table } from 'antd';
import { HttpStatusCode } from '@/fetch/core/constant';
import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import { translatorEnum } from '@/utils/util';
import { request } from '@/fetch/core';
import { Method } from '@/fetch/core/util';
const fetchApi = new IssueApi();
interface Props {
  vehicleName: string;
}
const ManualEventRecord = (props: Props) => {
  const { vehicleName } = props;
  const [tableData, setTableData] = useState<any>([]);
  const [currentPhone, setCurrentPhone] = useState(null);
  useEffect(() => {
    getManualEventList();
  }, []);
  const getManualEventList = async () => {
    try {
      const res = await fetchApi.getManualAlarmList(vehicleName);
      if (res.code === HttpStatusCode.Success) {
        setTableData(res.data);
      }
    } catch (err) {
      console.error(err);
    }
  };
  const resetTableData = (list: any, updateSecret: Function) => {
    if (!list) {
      return [];
    }
    const newList: any[] = list.map((item: any) => {
      if (typeof item.secret === 'undefined') {
        item.secret = true;
      }
      return {
        ...item,
        phone: { item, updateSecret },
      };
    });
    return newList;
  };
  const getPhone = async (record: any) => {
    const res: any = await request({
      path: '/permission/web/user/get_extend_user_info',
      method: Method.POST,
      body: {
        userName: record.reportUser,
      },
    });
    if (res.code === HttpStatusCode.Success) {
      setCurrentPhone(res.data.phone);
    }
  };
  const updatePhoneSecret = (reportTime: any, secret: any) => {
    setTableData(
      tableData.map((item: any) => {
        if (item.reportTime === reportTime) {
          return {
            ...item,
            secret: secret,
          };
        } else {
          return {
            ...item,
            secret: true,
          };
        }
      })
    );
  };
  const columns: any[] = [
    {
      title: '提报人',
      dataIndex: 'reportUser',
      align: 'left',
    },
    {
      title: '提报时间',
      dataIndex: 'reportTime',
      align: 'left',
    },
    {
      title: '问题描述',
      dataIndex: 'description',
      align: 'left',
      ellipse: true,
    },
    {
      title: '提报端',
      dataIndex: 'source',
      align: 'left',
      render: (text: string, record: any) => {
        return <>{translatorEnum('MANUAL_ALARM_SOURCE_ENUM', record.source)}</>;
      },
    },
    {
      title: '联系方式',
      dataIndex: 'phone',
      align: 'left',
      fixed: 'right',
      render: (params: any, record: any) => {
        return (
          <div
            style={{
              display: 'flex',
              width: '100%',
            }}
          >
            {!params.item.secret && currentPhone
              ? currentPhone
              : params.item.phone}
            <div
              style={{ paddingLeft: '5px' }}
              onClick={() => {
                if (params.item.secret) {
                  getPhone(record);
                }
                params.updateSecret(record.reportTime, !params.item.secret);
                setCurrentPhone(null);
              }}
            >
              {params.item.secret ? <EyeInvisibleOutlined /> : <EyeOutlined />}
            </div>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <Table
        rowKey={'reportTime'}
        columns={columns}
        dataSource={resetTableData(tableData, (reportTime: any, secret: any) =>
          updatePhoneSecret(reportTime, secret)
        )}
        pagination={false}
        scroll={{
          y: 1030,
        }}
      ></Table>
    </>
  );
};
export default React.memo(ManualEventRecord);
